import { Reducer } from 'redux';
import { HomeActionTypes, HomeState } from './types';

export const initialState: HomeState = {
  enquiries: [],
  isLoading: false,
  searchJobIdUserRefData: undefined,
  isSearchingJobIdUserRef: false,
  teamEnquirerList: undefined,
  isLoadingTeamEnquirer: false,
  state: 'loading'
};

const reducer: Reducer<HomeState> = (state = initialState, action: any) => {
  switch (action.type) {
    case HomeActionTypes.GET_ENQUIRIES_START: {
      return {
        ...state,
        isLoading: true,
        enquiries: []
      };
    }
    case HomeActionTypes.GET_ENQUIRIES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        enquiries: action.payload
      };
    }
    case HomeActionTypes.GET_ENQUIRIES_FAILURE: {
      return {
        ...state,
        isLoading: false,
        enquiries: []
      };
    }
    case HomeActionTypes.SEARCH_JOB_ID_USER_REF_START: {
      return {
        ...state,
        searchJobIdUserRefData: undefined,
        isSearchingJobIdUserRef: true
      };
    }
    case HomeActionTypes.SEARCH_JOB_ID_USER_REF_SUCCESS: {
      return {
        ...state,
        searchJobIdUserRefData: action.payload,
        isSearchingJobIdUserRef: false
      };
    }
    case HomeActionTypes.SEARCH_JOB_ID_USER_REF_FAILURE: {
      return {
        ...state,
        searchJobIdUserRefData: undefined,
        isSearchingJobIdUserRef: false
      };
    }
    case HomeActionTypes.GET_TEAM_ENQUIRER_LIST_START: {
      return {
        ...state,
        isLoadingTeamEnquirer: true,
        teamEnquirerList: undefined
      };
    }
    case HomeActionTypes.GET_TEAM_ENQUIRER_LIST_SUCCESS: {
      return {
        ...state,
        isLoadingTeamEnquirer: false,
        teamEnquirerList: action.payload
      };
    }
    case HomeActionTypes.GET_TEAM_ENQUIRER_LIST_FAILURE: {
      return {
        ...state,
        isLoadingTeamEnquirer: false,
        teamEnquirerList: undefined
      };
    }
    case HomeActionTypes.GET_CREDENTIAL_START: {
      return {
        ...state,
        state: 'loading'
      };
    }
    case HomeActionTypes.GET_CREDENTIAL_FAILURE: {
      return {
        ...state,
        state: 'fail',
        error: action.payload
      };
    }
    case HomeActionTypes.GET_CREDENTIAL_SUCCESS: {
      return {
        ...state,
        state: 'success',
        credentials: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
